import { render, staticRenderFns } from "./PatientPreviousCases.vue?vue&type=template&id=3f5c6f5e&scoped=true&"
import script from "./PatientPreviousCases.vue?vue&type=script&lang=js&"
export * from "./PatientPreviousCases.vue?vue&type=script&lang=js&"
import style0 from "./PatientPreviousCases.vue?vue&type=style&index=0&id=3f5c6f5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5c6f5e",
  null
  
)

export default component.exports